import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";
import { KeyRound, ArrowLeft } from "lucide-react";

export default function ResetPassword() {
  const nav = useNavigate();
  const [token, setToken] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const strong = (p) => p.length >= 12 && /[a-z]/.test(p) && /[A-Z]/.test(p) && /\d/.test(p);
  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("Şifreler eşleşmiyor");
    setBusy(true);
    try {
      await api.post("/auth/password/reset", { token: token.trim(), new_password: pw });
      toast.success("Şifre güncellendi — lütfen tekrar giriş yapın");
      nav("/login", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Sıfırlama başarısız");
    } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-[#faf7f2] flex items-center justify-center p-6">
      <form onSubmit={submit} className="w-full max-w-md card-lux p-8" data-testid="reset-root">
        <div className="mb-4"><Link to="/login" className="text-xs text-stone-500 hover:text-amber-700 inline-flex items-center gap-1"><ArrowLeft className="w-3 h-3" /> Girişe dön</Link></div>
        <div className="flex items-center gap-2 mb-3"><KeyRound className="w-5 h-5 text-amber-700" /><h1 className="font-serif-display text-2xl">Şifre Sıfırla</h1></div>
        <label className="block text-xs font-semibold uppercase tracking-wider text-stone-500 mb-2">Sıfırlama Token'ı</label>
        <input data-testid="reset-token" required value={token} onChange={(e) => setToken(e.target.value)} className="w-full mb-3 px-3 py-2 rounded-lg border border-stone-200 outline-none focus:border-amber-500 font-mono-code text-xs" placeholder="E-postadan gelen token" />
        <label className="block text-xs font-semibold uppercase tracking-wider text-stone-500 mb-2">Yeni Şifre (≥12 karakter)</label>
        <input data-testid="reset-pw" required type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="w-full mb-1 px-3 py-2 rounded-lg border border-stone-200 outline-none focus:border-amber-500" />
        <div className={`text-[11px] mb-2 ${strong(pw) ? "text-emerald-700" : "text-stone-500"}`}>{strong(pw) ? "✓ Güçlü şifre" : "En az 12 karakter, büyük/küçük harf ve rakam içermelidir"}</div>
        <input data-testid="reset-pw2" required type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="w-full mb-4 px-3 py-2 rounded-lg border border-stone-200 outline-none focus:border-amber-500" placeholder="Yeni şifre (tekrar)" />
        <button data-testid="reset-submit" type="submit" disabled={busy || !strong(pw) || pw !== pw2 || !token} className="w-full py-3 rounded-lg gold-gradient text-white disabled:opacity-60">{busy ? "Güncelleniyor..." : "Şifreyi Güncelle"}</button>
      </form>
    </div>
  );
}
